import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { setMarketingReferralCookie } from 'utils/referral-cookie';

export default function ReferralCapturePage(): null {
    const navigate = useNavigate();
    const { token } = useParams<{ token: string }>();

    useEffect(() => {
        // Referral attribution is only meaningful before authentication. An
        // already signed-in account must never overwrite a browser referral.
        if (!localStorage.getItem('token') && token) {
            setMarketingReferralCookie(token);
        }

        navigate('/', { replace: true });
    }, [navigate, token]);

    return null;
}
